import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Transition, TRANSITION_STATUS_ENTERING, TRANSITION_STATUS_ENTERED, TRANSITION_STATUS_EXITING, TRANSITION_STATUS_EXITED, TRANSITION_STATUS_UNMOUNTED, } from '@/components/functional/Animation/Transition';
/** 濃淡の設定 */
const opacities = {
    light: 'opacity-20',
    strong: 'opacity-70',
};
/** アニメーション速度（TailwindCSSとTransitionコンポーネントのアニメーション秒数を一致させるため） */
const durations = {
    fast: {
        className: 'duration-[300ms]',
        timeout: 300,
    },
    normal: {
        className: 'duration-[500ms]',
        timeout: 500,
    },
};
/** アニメーション設定 */
const animations = {
    [TRANSITION_STATUS_ENTERED]: 'opacity-100',
    [TRANSITION_STATUS_ENTERING]: 'opacity-100',
    [TRANSITION_STATUS_EXITED]: 'opacity-0',
    [TRANSITION_STATUS_EXITING]: 'opacity-0',
    [TRANSITION_STATUS_UNMOUNTED]: '',
};
export const Overlay = (props) => {
    const { children, className = '', duration = 'normal', innerClassName = '', isShow, onClick, opacity = 'strong', } = props;
    return (_jsx(Transition, Object.assign({ isShow: isShow, timeout: durations[duration].timeout }, { children: (status) => (_jsx("div", Object.assign({ className: className }, { children: _jsxs("div", Object.assign({ className: clsx('transition-opacity', 'fixed top-0 bottom-0 right-0 left-0 z-50', durations[duration].className, animations[status], innerClassName) }, { children: [_jsx("div", { className: clsx('absolute top-0 bottom-0 right-0 left-0', 'bg-black', opacities[opacity]), onClick: onClick, role: 'presentation' }), children !== null && children !== void 0 ? children : null] })) }))) })));
};
